export default __webpack_public_path__ + "static/media/notSavedBookmark.f214893b.svg";